// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Blog Page Custom CSS */
.blog-container {
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.blog-content {
  flex: 2 1;
}

.recent-posts {
  flex: 1 1;
 
}

/* .recent-posts h2 {
  margin-bottom: 20px;
} */

.blog-image {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
  display: block;   /* Prevents inline spacing issues */
  object-fit: contain;
  border-radius: 0px;
  
}

  
#blog-title{
    font-size: 30px;
    font-weight: 500;
    color: black;
    
}

`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/blog.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;;AAET;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc,IAAI,mCAAmC;EACrD,mBAAmB;EACnB,kBAAkB;;AAEpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;;AAEhB","sourcesContent":["/* Blog Page Custom CSS */\n.blog-container {\n  display: flex;\n  flex-direction: row;\n  gap: 30px;\n}\n\n.blog-content {\n  flex: 2;\n}\n\n.recent-posts {\n  flex: 1;\n \n}\n\n/* .recent-posts h2 {\n  margin-bottom: 20px;\n} */\n\n.blog-image {\n  width: 100%;\n  height: auto;\n  margin-bottom: 20px;\n  display: block;   /* Prevents inline spacing issues */\n  object-fit: contain;\n  border-radius: 0px;\n  \n}\n\n  \n#blog-title{\n    font-size: 30px;\n    font-weight: 500;\n    color: black;\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
